import {timestampToTime, deepCopy, getCookie} from "@/utils"
import {mapGetters} from 'vuex'
import {
    savePaper,
    getServerTime,
    saveTemp,
    getPapaerViewCharacteristic

} from '@api'
import { checkIsHasTempRecordActivityReq,checkPaperViewIsDoneActivityReq } from '@api/activity'

export default {
    computed: {
        ...mapGetters([
            'visibleCalc',
            'commonInfo',
            'quesTypeShowMap',
            'quesShowList',
            'userAnsMap',
            'submitData',
            'questions',
            'currentQuestion',
            'currentQuestionType',
            'currentQuestionIndex'
        ]),
        preDisabled() {
            return (parseInt(this.currentQuestionType) === 0 && parseInt(this.currentQuestionIndex) === 0)
        },
        nextDisabled() {
            let lastQuesType = this.questions.length - 1
            return (parseInt(this.currentQuestionType) === lastQuesType && parseInt(this.currentQuestionIndex) === this.questions[lastQuesType].list.length - 1)
        },
        unAnswerLen() {
            if (this.questions) {
                let examInfo = this.isNotAnswer()
                if (examInfo && examInfo.unAnswer) {
                    return examInfo.unAnswer.length || 0
                }
                return 0
            }
            return 0
        },
        quesNum() {
            if (this.questions) {
                let allQuesNum = 0;
                this.questions.forEach((item) => {
                    const num1 = item.list.length
                    allQuesNum = allQuesNum + num1
                })
                return allQuesNum
            }
        },
    },
    created() {
        let that = this
        this.timer = setInterval(async () => {
            let examInfo = that.isNotAnswer()
            if (!examInfo.flag && !this.commitStatus) {
                let params = await that.saveParams()
                saveTemp(params)
            }
        }, 180000)
    },
    methods: {
        //打开选择大题题型页面
        showExamPage(isStartChoose) {
            //console.log('isStartChoose=', isStartChoose)
            this.isStart = false
            this.isStartChoose = isStartChoose
        },
        //点击继续，进入题型开始考试
        examStart(isStart) {
            this.isStart = isStart
            this.isStartChoose = false
        },
        async initExam() {
            if (this.stage === 0) {
                this.$message.warning('预约阶段，不能答题')
                return
            }
            await this.checkTempSave()
        },
        async getPaperInformation() {
            let params = {
                flag: this.flag,
                siteCourseID: this.siteCourseID,
                userID: this.uid,
                temp: this.temp,
                courseID: this.courseID,
                bizID: this.bizID,
                saveBizID: this.saveBizID,
                source: this.source
            }
            if (this.centerID) {
                params['centerID'] = this.centerID
            }
          await this.$store.dispatch('getAllInformation', params)
            .then((res) => {
              //初始化当前题目，默认为第一大题第一小题
              //初始化考试时间倒计时
              this.$store.dispatch('setCurQues', this.questions[this.currentQuestionType].list[this.currentQuestionIndex])
              this.examName = res.commonInfo.examName
              this.courseName = res.commonInfo.courseName
              this.endTimes = this.commonInfo.lastTime || 7200
              // this.endTimes = 5
              this.isVisibleQueDetail = true
              this.isShowRecord = res.commonInfo.isShowRecord || 1
            })
            .catch(err => {
                alert(err.msg)
                if (err.errorCode === '-1') window.location.href = '//www.chinaacc.com/zhongjizhicheng/zhuanti/mokao/'
            })
        },
        //根据试卷特色进行展示的数据
        async getPapaerViewCharacteristicFun() {
            const {includeTempButAbandon} = this.$route.query
            if (this.temp === 2 || (includeTempButAbandon && includeTempButAbandon === '1')) {
                this.isTemp = true
                if (this.temp === 1) this.spendTime = 0
            } else {
                this.isTemp = false
            }

            let params = {
                saveBizID: this.isTemp === true ? this.bizID : this.saveBizID,
                courseID: this.courseID,
                saveBizType: this.isTemp === true ? 1 : 0
            }

            await getPapaerViewCharacteristic(params).then(res => {
                // res.answerIsShow === '1' ? this.isShowAnswer = true : this.isShowAnswer = false
                res.answerQuestion === '1' ? this.isShowAnswerQuestion = true : this.isShowAnswerQuestion = false
                res.collect === '1' ? this.isShowCollect = true : this.isShowCollect = false
                res.videoExplain === '1' ? this.isShowVideoExplain = true : this.isShowVideoExplain = false
                res.pointAssessment === '1' ? this.isShowPointAssessment = true : this.isShowPointAssessment = false
                res.proposal === '1' ? this.isShowProposal = true : this.isShowProposal = false
                res.qzSeat === '1' ? this.isShowQzSeat = true : this.isShowQzSeat = false
                this.faqlUrl = res.faqlUrl
            })
        },

        //系数表弹框
        toggleTable(isShow) {
            this.isVisibleTable = isShow
            this.isVisibleTableTaxLaw = false
            this.isVisibleAnswer = false
        },
        //税务表弹框
        toggleTableTaxLaw(isShow) {
            this.isVisibleTable = false
            this.isVisibleTableTaxLaw = isShow
            this.isVisibleAnswer = false
        },
        //参考答案弹框
        toggleAnswer(isShow) {
            this.isVisibleTable = false
            this.isVisibleTableTaxLaw = false
            this.isVisibleAnswer = isShow
        },

        //试卷试题列表
        toggleQuesList(isShow, from) {
            this.isVisibleQueDetail = !isShow
            this.isVisibleQueList = isShow
            if (from === '1') {
                const quesTypeID = this.currentQuestion.quesTypeID
                if (quesTypeID === 4 || quesTypeID === 5) {
                    let hasChildDom = this.$refs['hasChildQuestion']
                    let withoutChildDom = this.$refs['withoutChildQuestion']
                    if (hasChildDom) {
                        hasChildDom.setCurrentSmallContent(this.currentQuestion)
                    } else if (withoutChildDom) {
                        withoutChildDom.setCurrentSmallContent(this.currentQuestion)
                    }
                }
            }
        },
        //标记按钮
        markToggleFn() {
            this.$store.dispatch('setIsMark')
        },
        //倒计时结束自动交卷
        async endToSubmit() {
            const quesTypeID = this.currentQuestion.quesTypeID
            if (quesTypeID === 4 || quesTypeID === 5) {
                this.setCurrentSmallContentFn()
                /* let hasChildDom = this.$refs['hasChildQuestion']
                 let withoutChildDom = this.$refs['withoutChildQuestion']
                 if (hasChildDom) {
                   await hasChildDom.setCurrentSmallContent(this.currentQuestion)
                 } else if (withoutChildDom) {
                   await withoutChildDom.setCurrentSmallContent(this.currentQuestion)
                 }*/
            }

            // 交卷方法
            let examInfo = this.isNotAnswer()
            if (!examInfo.flag) {
                let params = await this.saveParams()
                this.commitStatus = true
                savePaper(params).then(res => {
                    this.questionsMap = deepCopy(this.questions)
                    this.bizID = res.bizID
                    this.endExamFlag = true
                    clearInterval(this.timer)
                    this.commitStatus = false
                }).catch(err => {
                    this.commitStatus = false
                    this.$message.error(err.msg)
                })
            } else {
                this.$alert('倒计时时间到，您并未作答,请重新选择试卷！', '', {
                    confirmButtonText: '确定',
                    callback() {
                        window.location.href = "about:blank"
                        window.close()
                    }
                });
            }
        },

        //点击交卷按钮
        async handOverFn() {
            const quesTypeID = this.currentQuestion.quesTypeID
            if (quesTypeID === 4 || quesTypeID === 5) {
                this.setCurrentSmallContentFn()
                /*let hasChildDom = this.$refs['hasChildQuestion']
                let withoutChildDom = this.$refs['withoutChildQuestion']
                if (hasChildDom) {
                  await hasChildDom.setCurrentSmallContent(this.currentQuestion)
                } else if (withoutChildDom) {
                  await withoutChildDom.setCurrentSmallContent(this.currentQuestion)
                }*/
            }
            //多选判断
            /*if(this.currentQuestion.quesTypeID === 2 && this.currentQuestion.userAnswer.length === 1) {
              this.multiStatus = true
              this.visibleAlert = true
              return
            }*/
            this.visibleAlert = true
        },

        //结束考试
        async endToSave() {
            if (this.commitStatus) {
                alert('提交中，请勿重复点击~')
                return
            }
            const quesTypeID = this.currentQuestion.quesTypeID
            if (quesTypeID === 4 || quesTypeID === 5) {
                this.setCurrentSmallContentFn()
                /*let hasChildDom = this.$refs['hasChildQuestion']
                let withoutChildDom = this.$refs['withoutChildQuestion']
                if (hasChildDom) {
                  await hasChildDom.setCurrentSmallContent(this.currentQuestion)
                } else if (withoutChildDom) {
                  await withoutChildDom.setCurrentSmallContent(this.currentQuestion)
                }*/
            }

            // 交卷方法
            this.commitStatus = true
            let params = await this.saveParams()
            savePaper(params).then(res => {
                this.questionsMap = deepCopy(this.questions)
                this.bizID = res.bizID
                this.saveBizID = res.saveBizID
                this.endExamFlag = true
                this.endTimes = 0
                clearInterval(this.timer)
                this.commitStatus = false
                this.visibleAlert = false
            }).catch(err => {
                this.commitStatus = false
                this.$message.error(err.msg)
            })
        },
        //保存试卷参数
        async saveParams() {  //  提交四大对象
            let quesTypeShowMap = JSON.parse(JSON.stringify(this.quesTypeShowMap))
            for (let i in quesTypeShowMap) {
                if (quesTypeShowMap[i].list) {
                    delete quesTypeShowMap[i].list
                }
            }
            let userAnswerParams = {
                userAnsMap: {},
                quesShowList: this.quesShowList,
                quesTypeShowMap: quesTypeShowMap,
                commonInfo: {}
            }
            let otherData = {...this.submitData}

            let curTime = await getServerTime(() => {
            }).catch(e => {
            })
            let commonInfoOther = {
                createTime: timestampToTime(curTime),
                userID: this.uid,
                userName: getCookie('username'),
                spendTime: this.commonInfo.contestTimeLimit * 60 - this.endTimes,
                paperScore: otherData.paperScore,
                allQuesNum: otherData.allQuesNum,
                allChildQuesNum: otherData.allChildQuesNum,
                quesTypeResultList: otherData.quesTypeResultList,
                siteCourseID: this.siteCourseID,
                lastTime: this.endTimes
            }

            let commonInfoCopy = {...this.commonInfo, ...commonInfoOther}
            this.$store.commit('SET_COMMON_INFO', commonInfoCopy)

            userAnswerParams.commonInfo = commonInfoCopy
            userAnswerParams.userAnsMap = this.userAnsMapFormat(this.questions)
            return userAnswerParams
        },
        //用户答案对象格式化，将questions中的题目重新整理成提交的userAnsMap对象
        userAnsMapFormat(obj) {
            let result = {}
            let copyQuestions = deepCopy(obj)
            copyQuestions.forEach(quesType => {
                quesType.list.forEach(ques => {
                    if (ques.quesTypeID === 2) {
                        //处理临时保存返回的数据为字符串不是数组的情况，则不需要转字符串
                        let flag = Array.isArray(ques.userAnswer)
                        if (flag) ques.userAnswer = ques.userAnswer.sort().join('')
                    }
                    let smallContent = ques.smallContent
                    if (smallContent && smallContent.length) {
                        smallContent.forEach(smallQues => {
                            result[smallQues.questionID] = smallQues
                            if (smallQues.quesTypeID === 2 && smallQues.userAnswer !== null) {
                                //处理临时保存返回的数据为字符串不是数组的情况，则不需要转字符串,此种题型为大题套小题且小题为不定项选择题时，有临时保存回显时会出现
                                let flag = Array.isArray(smallQues.userAnswer)
                                if (flag) smallQues.userAnswer = smallQues.userAnswer.sort().join('')
                            }
                        })
                        delete (ques.smallContent)
                    }
                    result[ques.questionID] = ques
                })
            })

            return result
        },
        //确定是否没有答题
        isNotAnswer() {
            let allQuestions = []
            Object.values(this.questions).forEach((item, index) => {
                allQuestions[index] = []
                allQuestions[index] = [...item.list]
            })
            allQuestions = Array.prototype.concat([], ...allQuestions)
            this.alertWindow.allQuestions = allQuestions
            this.alertWindow.courseName = this.commonInfo.examName || getCookie('courseName') || getCookie('exerciseName')
            let flag = allQuestions.every(item => {
                //  大题套小题
                if (item.smallContent) {
                    let res = item.smallContent.some(smallQues => {
                        let hasAnswer = false
                        if (smallQues.attAnswer) {
                            // hasAnswer = smallQues.tempAnswer === 'true'
                            hasAnswer = smallQues.isAnswer === 1
                        } else {
                            hasAnswer = smallQues.userAnswer && smallQues.userAnswer.length > 0
                        }
                        return hasAnswer
                    })
                    return !res
                } else {
                    if (item.userAnswer instanceof Array) {  //  多选题
                        return item.userAnswer.length === 0
                    } else {
                        //  其他简单题型
                        let hasAnswer = false
                        if (item.attAnswer) {
                            hasAnswer = item.tempAnswer === 'true'
                        } else {
                            hasAnswer = item.userAnswer && item.userAnswer.length > 0
                        }
                        return !hasAnswer
                    }
                }
            })
            let unAnswer = allQuestions.filter(item => {
                if (item.smallContent) {  //  大题套小题
                    let res = item.smallContent.some((smallQues) => {
                        let hasAnswer = false
                        if (smallQues.attAnswer) {
                            //核实答题区里有表格答题时已答题数问题时注掉 smallQues.tempAnswer === 'true' 选用 smallQues.isAnswer === 1
                            //hasAnswer = smallQues.tempAnswer === 'true'
                            hasAnswer = smallQues.isAnswer === 1
                        } else {
                            hasAnswer = smallQues.userAnswer && smallQues.userAnswer.length > 0
                        }
                        return hasAnswer
                    })
                    return !res
                } else {
                    if (item.userAnswer instanceof Array) {  //  多选题
                        return item.userAnswer.length === 0
                    } else {  //  其他简单题型
                        let hasAnswer = false
                        if (item.attAnswer) {
                            hasAnswer = item.tempAnswer === 'true'
                        } else {
                            hasAnswer = item.userAnswer && item.userAnswer.length > 0
                        }
                        return !hasAnswer
                    }
                }
            })
            return {
                allQuestions,
                unAnswer,
                flag
            }
        },

        //结束考试后，查看考试解析
        async viewResults() {
            clearInterval(this.timer)
            // window.location.href = `//member.chinaacc.com/qzs/index.html#/analysis/viewReport?identity=-2&isDoneLocation=1&siteCourseID=${this.siteCourseID}&courseID=${this.courseID}&paperViewID=${this.saveBizID}&bizID=${this.bizID}`
            let params = {
                userID: this.getUserId(),
                paperViewID: this.saveBizID,
                activityID: this.activityID
            }

            const res = await checkPaperViewIsDoneActivityReq(params)
            if (res) {
              let isDone = res.isDone // 1：做过 2：没做过 0: 不在模考时间内
              let paperScore = res.paperScore || 0
              let rankNum = res.rankNum || 0
              let rate = res.rate || 0
              let timeState = res.timeState || 0
              if (isDone === '0') {
                this.$message.warning('不在模考时间内')
                return
              }
              this.endExamFlag = false;
              return window.open(`//www.chinaacc.com/zhongjizhicheng/zhuanti/mokao/?stage=${this.stage}&courseId=${this.courseID}&paperScore=${paperScore}&rankNum=${rankNum}&rate=${rate}&timeState=${timeState}`, '_self')
            }

        },
        //给主观题打分

        async subjectiveQuestionsStore() {
            await this.$store.dispatch('getQuesAnaly', {flag: this.flag, bizID: this.bizID}).then(() => {
                this.questionsMap = deepCopy(this.questions)
            })
            this.endExamFlag = false
            this.visibleSub = true
            clearInterval(this.timer)
        },
        //计算器切换
        runCalc() {
            // this.$store.dispatch('toggleCalc')
            let flag = document.getElementById('my-calculator').style.display === 'none'
            if (flag) {
                document.getElementById('my-calculator').style.display = 'block'
            } else {
                document.getElementById('my-calculator').style.display = 'none'
            }
        },
        //切换题目(上一页下一页)
        async buttonChange(quesType, quesIndex, oldQues) {
            const quesTypeID = this.currentQuestion.quesTypeID
            if (quesTypeID === 4 || quesTypeID === 5) {
                this.setCurrentSmallContentFn()
            }
            await this.$store.dispatch('setCurQuesType', quesType)
            await this.$store.dispatch('setCurQuesIndex', quesIndex)
            await this.$store.dispatch('setCurQues', this.questions[quesType].list[quesIndex])
            this.toggleQuesList(false)
        },
        //切换题目(答题卡)
        async changeByQueListFun(quesType, quesIndex, oldQues) {
            //多选判断
            /* if(this.currentQuestion.quesTypeID === 2 && this.currentQuestion.userAnswer.length === 1) {
               this.multiStatus = true
               this.visibleAlert = true
               return
             }*/
            this.buttonChange(quesType, quesIndex, oldQues)
        },
        //主观题弹框关闭
        closeSubjective() {
            this.visibleSub = false
            this.viewResults()
        },

        //页签title
        timeFilter(value) {
            if (value) {
                let numToStr = number => (number > 9 ? number.toString() : '0' + number)
                let hr = parseInt((value / 60 / 60 % 24).toString())
                let min = parseInt((value / 60 % 60).toString())
                let sec = parseInt((value % 60).toString())
                return `本试卷将在${numToStr(hr)}小时${numToStr(min)}分${numToStr(sec)}秒后自动提交!`
            } else {
                return '本试卷将在00小时00分00秒后自动提交!'
            }
        },
        changeQues(type) {
            let newQuesType = this.currentQuestionType, newQuesIndex = this.currentQuestionIndex
            switch (type) {
                case 'prev':
                    /*if(this.currentQuestion.quesTypeID === 2 && this.currentQuestion.userAnswer.length === 1) {
                      this.multiStatus = true
                      this.visibleAlert = true
                      return
                    }*/
                    if (parseInt(this.currentQuestionIndex) === 0) {
                        if (newQuesType > 0) {
                            newQuesType--
                            newQuesIndex = this.questions[newQuesType].list.length - 1
                        }
                    } else {
                        newQuesIndex--
                    }
                    break
                case 'next':
                     if(this.currentQuestion.quesTypeID === 2 && this.currentQuestion.userAnswer.length === 1) {
                       this.multiStatus = true
                       this.visibleAlert = true
                       return
                     }
                    //如果当前小题的序号 = 该大题中最后一个小题序号，则转到下一个大题中
                    if (parseInt(this.currentQuestionIndex) === this.questions[this.currentQuestionType].list.length - 1) {
                        if (this.questions[this.currentQuestionType + 1]) {
                            newQuesIndex = 0
                            newQuesType++
                        }
                    } else {
                        newQuesIndex++
                    }
                    break
            }
            this.buttonChange(newQuesType, newQuesIndex, this.currentQuestion)
        },
        //检测是否有临时保存
        checkTempSave() {
            let params = {
                courseID: this.courseID,
                saveBizID: this.saveBizID,
                userID: this.uid,
                bizKey: 'activityPaper'
            }
            // 查询是否有临时保存试题
            checkIsHasTempRecordActivityReq(params).then(async res => {
                if (res !== -1) {
                    this.bizID = res
                    this.temp = 2
                    this.$alert('您中途离开了考试，将从上次离开时保存的进度继续答题', '提示', {
                        confirmButtonText: '确定'
                    })
                }
                await this.getPaperInformation()
                //await this.getPapaerViewCharacteristicFun()
            })
        },
        // 答完大题blur更新做题参数
        async setCurrentSmallContentFn() {
            const quesTypeID = this.currentQuestion.quesTypeID
            if (quesTypeID === 4 || quesTypeID === 5) {
                let hasChildDom = this.$refs['hasChildQuestion']
                let withoutChildDom = this.$refs['withoutChildQuestion']
                if (hasChildDom) {
                    await hasChildDom.setCurrentSmallContent(this.currentQuestion)
                } else if (withoutChildDom) {
                    await withoutChildDom.setCurrentSmallContent(this.currentQuestion)
                }
            }
        },
        // 获取userID
        getUserId() {
            const userID = getCookie('cdeluid') ? Number(getCookie('cdeluid')) : null
            return userID
        },
        // 未登录
        checkLogin() {
            if (getCookie('cdeluid')) {
                return true
            }
            this.$message.warning('未登录或登录已失效')
            // var loginRegisterHideClose = true
            window.CDEL.ucLogin() // 弹窗登录
        },
      //  切换题目(答题卡)
      async changeByQueList(quesType, quesIndex, oldQues) {
        /*const isMultiple = this.commonInfo.paperCatParam
          ? this.commonInfo.paperCatParam.slice(38, 39)
          : 0
        if (this.currentQuestion.quesTypeID === 2 && this.currentQuestion.userAnswer.length === 1 && isMultiple==='1') {
          // this.multiStatus = true
          // this.visibleAlert = true
          this.$message.warning('多选题最少选择2个选项哦~')
          return
        }*/

        if(this.currentQuestion.quesTypeID === 2 && this.currentQuestion.userAnswer.length === 1) {
          this.multiStatus = true
          this.visibleAlert = true
          return
        }

        this.buttonChange(quesType, quesIndex, oldQues)
      },
    }
}
